import React from "react";
import {useTranslation} from "react-i18next";
import '../i18/config';
import {MainErrorType} from "../redux/Main/common";
import {errorDetails, errorMessage} from "../helpers/errors";

interface ErrorReasonsProps {
    errors?: MainErrorType[] | null;
    className?: string;
}

/**
 * Why something failed: the reason in the reader's language, with the social network's own words
 * folded away underneath.
 */
const ErrorReasons = ({errors, className}: ErrorReasonsProps) => {
    const {t} = useTranslation(['peerActivity']);

    if (!errors || errors.length === 0) {
        return null;
    }

    return (
        <div className={"text-danger fs-12 " + (className || '')}>
            {errors.map((error: MainErrorType, key: number) => {
                const details = errorDetails(error);

                return (
                    <div key={"errorReason" + key} className="mb-1">
                        <i className="ri-error-warning-line align-bottom me-1"/>
                        {errorMessage(error)}
                        {details !== null &&
                            <details className="text-muted">
                                <summary>{t('peerActivity:publishErrorDetails')}</summary>
                                {details}
                            </details>
                        }
                    </div>
                );
            })}
        </div>
    );
};

export default ErrorReasons;
